import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { QnaDetailVo } from '@/types/qna';

import { AdPageType } from '@/models/ad/list';
import { GoogleAdSense, UnifiedAdBanner } from '@/shared/ui';
import { Client } from '@/types/app';
import { cn } from '@/utils/style';
import AnswerDetail, { AnswerDetailProps } from './answer-detail';

interface QnaAnswersProps extends Omit<AnswerDetailProps, 'answer' | 'advertisementComponent'> {
  qnaDetail: QnaDetailVo;
  moveToHospitalDetail: (hospitalPid: string) => void;
  client: Client;
}
const QnaAnswers: FunctionComponent<QnaAnswersProps> = ({
  qnaDetail,
  onShowModal,
  onClickLikeAnswer,
  onClickMagazine,
  moveToHospitalDetail,
  moveToDoctorDetailPage,
  onClickWriteReview,
  onClickOuterLink,
  questionPid,
  extractTextFromChildren,
  client,
}) => {
  return (
    <AnswerWrapper>
      <AnswerCount>
        {qnaDetail.category.name} 관련 {qnaDetail.answererCount}개의 답변
      </AnswerCount>

      <AnswerList>
        {qnaDetail.answers.map((answer, i) => (
          <AnswerDetail
            key={`qna_answer_${answer.answerPid}`}
            answer={answer}
            isAiAnswerChecked={qnaDetail.isAiAnswerChecked}
            categoryName={qnaDetail.category.name}
            onShowModal={onShowModal}
            onClickLikeAnswer={onClickLikeAnswer}
            onClickMagazine={onClickMagazine}
            moveToHospitalDetail={moveToHospitalDetail}
            moveToDoctorDetailPage={moveToDoctorDetailPage}
            onClickWriteReview={onClickWriteReview}
            onClickOuterLink={onClickOuterLink}
            questionPid={questionPid}
            extractTextFromChildren={extractTextFromChildren}
            advertisementComponent={
              i === 0 && !client.isWebView ? (
                <UnifiedAdBanner
                  adPageType={AdPageType.QnaDetailAnswerMiddleBanner}
                  client={client}
                  borderRadius={client.isMobile ? 8 : 0}
                  className={cn({
                    'px-[24px]': client.isMobile,
                  })}
                  fallbackContent={
                    <GoogleAdSense
                      client={client}
                      adPageType={AdPageType.QnaDetailAnswerMiddleBanner}
                      wrapperClassName={cn('my-[16px] flex w-full h-[280px] items-center justify-center')}
                      style={{
                        width: 336,
                        height: 280,
                      }}
                      className='w-full'
                    />
                  }
                />
              ) : null
            }
          />
        ))}
      </AnswerList>
    </AnswerWrapper>
  );
};

export default QnaAnswers;

const AnswerWrapper = styled.div`
  min-height: 100%;
`;

const AnswerCount = styled.h2`
  padding: 8px 24px 24px;
  ${({ theme }) => `
    ${theme.typography.UI18SB};
    color: ${theme.color.gray800};
    background: ${theme.color.gray30}
  `}
`;

const AnswerList = styled.ul``;
